import { createFeatureSelector } from '@ngrx/store';

import { MODULE_KEY } from '../../constants';
import { ProcessingState } from '../reducers';

export const selectProcessingModuleState =
  createFeatureSelector<ProcessingState>(MODULE_KEY);
